<div class="d-flex align-items-center" *ngIf="!newIcon">
  <img [src]="'./assets/images/vip' + image + '.png' | absUrl" style="margin-right: 5px;" [style.width.px]="width"
    *ngIf="isVip" />
  <span *ngIf="!noText" class="text" [ngClass]="{isVip: isVip}">
    <b>{{text}}</b>
  </span>
</div>

<div class="d-flex align-items-center outer-icon-box" *ngIf="newIcon && !!membership">
  <div class="vip-icon-box {{ membership }}">
  </div>
  <span *ngIf="!noText" class="text ml-1 vip-icon-text {{ membership }}" [ngClass]="{isVip: isVip, 'mLeft':textML}">
    <b>{{text}}</b>
  </span>
  <div *ngIf="canHover" class="hover-icon-box {{ membership }}">
    <div class="d-flex align-items-center justify-content-center">
      <div class="vip-icon-box {{ membership }}"></div>
      <span class="text ml-1 vip-icon-text {{ membership }}" [ngClass]="{isVip: isVip, small: !isVip}">
        {{ isVip ? text : '未开通VIP'}}
      </span>
    </div>
    <div class="box-bottom-arrow"></div>
  </div>
</div>